<template>
  <div>
    <v-dialog v-model="visible" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <v-icon color="orange" left>mdi-alert-decagram</v-icon>
          Reconsideración de Marcación
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <strong>Entrada Marcación:</strong>
              <div>{{ formatDateTime(detail.MkrIn) }}</div>
            </v-col>
            <v-col cols="6">
              <strong>Salida Marcación:</strong>
              <div>{{ formatDateTime(detail.MkrOut) }}</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <s-date label="Fecha Entrada" v-model="detail.BeginDate" :min="minEntryDate" :max="maxEntryDate" no-title
                dense />
            </v-col>
            <v-col cols="6">
              <s-text type="time" v-model="detail.BeginTime" label="Hora Entrada" :rules="[(v) => !!v || 'Obligatorio']"
                dense />
            </v-col>
            <v-col cols="6">
              <s-date label="Fecha Salida" v-model="detail.EndDate" :min="minEntryDate" :max="maxExitDate" no-title
                dense />
            </v-col>
            <v-col cols="6">
              <s-text type="time" v-model="detail.EndTime" label="Hora Salida" :rules="[(v) => !!v || 'Obligatorio']"
                dense />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea v-model="observation" label="Observación"
                :rules="[(v) => !!v || 'La observación es obligatoria']" required />
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-file-input label="Anexo (Sustento)" v-model="attachmentFile"
                :rules="[(v) => !!v || 'El anexo es obligatorio']" placeholder="Selecciona un archivo"
                persistent-placeholder required dense />
            </v-col>
          </v-row>
          <v-alert v-if="validationError" type="error" dense class="mb-2">{{
            validationError
            }}</v-alert>
          <v-divider class="my-2"></v-divider>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" @click="onSave" :disabled="!canSave">
              <v-icon left>mdi-content-save</v-icon>
              Guardar
            </v-btn>
            <v-btn text @click="$emit('close')">
              <v-icon left>mdi-close</v-icon>
              Cancelar
            </v-btn>
          </v-card-actions>
          <div v-if="history && history.length > 0">
            <h4>Historial de reconsideraciones</h4>
            <v-timeline dense>
              <v-timeline-item v-for="(rec, idx) in history" :key="rec.ReconsiderationID ? rec.ReconsiderationID : idx"
                :color="rec.SecStatus == 0 ? '#ef4444' : '#10b981'" small>
                <div class="timeline-card">
                  <!-- Contenido principal -->
                  <div class="timeline-content">
                    <div class="status-badge" :class="{
                      active: rec.SecStatus == 1 && rec.MrkStatus != 1,
                      cancelled: rec.SecStatus == 0,
                      reconsideration: rec.MrkStatus == 1,
                    }">
                      <span>{{
                        rec.SecStatus == 0 ? "●" : rec.MrkStatus == 1 ? "◐" : "●"
                        }}</span>
                      {{
                        rec.SecStatus == 0
                          ? "Anulada"
                          : rec.MrkStatus == 1
                            ? "Reconsideración"
                            : "Activa"
                      }}
                    </div>

                    <div class="time-info">
                      <div class="time-slot">
                        <span class="time-label">Entrada</span>
                        <span class="time-value">{{
                          formatDateTime(rec.MrkNewEntryTime) || "-"
                          }}</span>
                      </div>
                      <div class="time-slot">
                        <span class="time-label">Salida</span>
                        <span class="time-value">{{
                          formatDateTime(rec.MrkNewExitTime) || "-"
                          }}</span>
                      </div>
                    </div>

                    <div class="observation" v-if="rec.MrkObservation">
                      "{{ rec.MrkObservation }}"
                    </div>
                  </div>

                  <!-- Botón al costado -->
                  <v-btn v-if="rec.AttachmentPath" class="download-btn" @click="onDownloadAttachment(rec)" small icon
                    title="Descargar Anexo">
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                  <div class="timeline-actions" v-if="rec.SecStatus == 1">
                    <v-btn class="revert-btn" @click="onRevert(rec)" small>
                      <v-icon left small>mdi-backup-restore</v-icon>
                      Revertir
                    </v-btn>
                  </div>
                </div>
              </v-timeline-item>
            </v-timeline>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="previewDialog" max-width="800px">
      <v-card>
        <v-card-title class="py-2">
          Vista previa
          <v-spacer />
          <v-btn icon small @click="previewDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <img :src="previewImage" v-if="previewImage" style="max-width: 100%; max-height: 600px;">
          <v-btn v-if="previewImage" small color="primary" class="mt-2"
            @click="downloadBase64(previewImage, 'anexo.png')">
            <v-icon left small>mdi-download</v-icon> Descargar
          </v-btn>
          </img>
          <div v-else>Sin imagen</div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import _sHmnHoursWorkedService from "@/services/HumanResource/HmnHoursWorkedService.js";
import GenUploadFiles from "@/services/General/GenUploadFiles";

export default {
  props: {
    detail: { type: Object, required: true },
    history: { type: Array, default: () => [] },
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      observation: "",
      validationError: "",
      attachmentFile: null,
      previewDialog: false,
      previewImage: null
    };
  },
  computed: {
    canSave() {
      // Validar que los campos de fecha/hora estén completos y válidos
      return (
        !!this.detail.BeginDate &&
        !!this.detail.BeginTime &&
        !!this.detail.EndDate &&
        !!this.detail.EndTime &&
        !!this.observation &&
        !!this.attachmentFile &&
        !this.validationError
      );
    },
    canRevert() {
      return this.history && this.history.length > 0 && this.history[0].SecStatus === 1;
    },
    minEntryDate() {
      // Fecha mínima: la fecha de la marcación original
      return this.detail.BeginDateTime
        ? this.formatDateISO(this.detail.BeginDateTime)
        : "";
    },
    maxEntryDate() {
      // Fecha máxima: la fecha de la marcación original + 1 día
      if (!this.detail.BeginDateTime) return "";
      const d = new Date(this.detail.BeginDateTime);
      d.setDate(d.getDate() + 1);
      return this.formatDateISO(d);
    },
    minExitDate() {
      // Igual que minEntryDate
      return this.minEntryDate;
    },
    maxExitDate() {
      // Fecha máxima: fecha de entrada + 1 día
      if (!this.detail.BeginDate) return this.maxEntryDate;
      const d = new Date(this.detail.BeginDate);
      d.setDate(d.getDate() + 1);
      return this.formatDateISO(d);
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.observation = "";
        this.validationError = "";
      }
    },
    "detail.BeginDate"() {
      this.validateFields();
    },
    "detail.BeginTime"() {
      this.validateFields();
    },
    "detail.EndDate"() {
      this.validateFields();
    },
    "detail.EndTime"() {
      this.validateFields();
    },
  },
  methods: {
    formatDateTime(val) {
      if (!val) return "-";
      let d = typeof val === "string" ? new Date(val) : val;
      if (isNaN(d.getTime())) return "-";
      if (this.$fun && this.$fun.formatDateTimeView) {
        return this.$fun.formatDateTimeView(d);
      }
      return d.toLocaleString("es-PE", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    formatDateISO(val) {
      // Devuelve yyyy-MM-dd
      const d = typeof val === "string" ? new Date(val) : val;
      if (isNaN(d.getTime())) return "";
      return d.toISOString().substr(0, 10);
    },
    formatDateTimeISO(val) {
      // recibe yyyy-MM-ddTHH:mm:ss.000Z Devuelve yyyy-MM-dd HH:mm:ss
      //quitarle T y despues del .
      val = val.replace("T", " ").replace(/\.\d+Z$/, "");
      if (!val) return "";
      return val;
    },
    validateFields() {
      this.validationError = "";
      if (
        !this.detail.BeginDate ||
        !this.detail.BeginTime ||
        !this.detail.EndDate ||
        !this.detail.EndTime
      ) {
        return;
      }
      const entry = new Date(`${this.detail.BeginDate} ${this.detail.BeginTime}:00`);
      const exit = new Date(`${this.detail.EndDate} ${this.detail.EndTime}:00`);
      if (exit < entry) {
        this.validationError =
          "La fecha/hora de salida no puede ser menor a la de entrada.";
        return;
      }
      // No más de un día de diferencia (pero no solo 24h, sino fecha)
      const maxExit = new Date(entry);
      maxExit.setDate(maxExit.getDate() + 2);
      if (exit > maxExit) {
        this.validationError =
          "La fecha/hora de salida no puede ser mayor a un día después de la entrada.";
        return;
      }
    },
    async onSave() {
      this.$fun
        .alert(
          "Al Aceptar, las inconsistencias se convertirán en E y/o S",
          "question"
        )
        .then(async () => {
          this.validateFields();
          if (this.validationError) {
            this.$fun.alert(this.validationError, "error");
            return;
          }

          // ✅ INICIO DEL BLOQUE DE CÓDIGO ACTUALIZADO
          let fileName = "";
          if (this.attachmentFile) {
            try {
              // Creamos un nombre de archivo único para la reconsideración
              const uniqueFileName = `Reconsideration_${this.detail.CacheDetailID}_${Date.now()}`;

              // Usamos el nuevo servicio de subida
              const respImg = await GenUploadFiles.upload(
                this.attachmentFile,
                uniqueFileName,
                'routeReconsiderations', // Módulo/Ruta donde se guardará
                true
              );

              // Obtenemos el nombre del archivo de la respuesta
              fileName = respImg.data.fileName;

            } catch (uploadError) {
              this.$fun.alert("Error al subir la foto de sustento.", "warning");
              console.error("Error al subir la foto", uploadError);
              return; // Detenemos si la subida falla
            }
          } else {
            this.$fun.alert("Debe seleccionar un archivo de sustento.", "error");
            return;
          }
          // ✅ FIN DEL BLOQUE DE CÓDIGO ACTUALIZADO

          const reconsideration = {
            CacheDetailID: this.detail.CacheDetailID,
            MarkingDate: this.formatDateISO(this.detail.BeginDateTime),
            PrevEntryTime: this.formatDateTimeISO(this.detail.MkrIn),
            PrevExitTime: this.formatDateTimeISO(this.detail.MkrOut),
            NewEntryTime: this.detail.BeginDate + " " + this.detail.BeginTime,
            NewExitTime: this.detail.EndDate + " " + this.detail.EndTime,
            Observation: this.observation,
            AttachmentPath: fileName, // Usamos el nombre de archivo devuelto por el servicio
          };

          try {
            await _sHmnHoursWorkedService.createReconsideration(
              reconsideration,
              this.$fun.getUserID()
            );
            this.$emit("refresh");
            this.$emit("close");
          } catch (error) {
            console.error("Error al guardar la reconsideración:", error);
            this.$fun.alert("Error al guardar la reconsideración", "error");
          }
        });
    },
    async onRevert(rec) {
      if (!this.canRevert) return;

      await _sHmnHoursWorkedService.revertReconsideration(
        rec.ReconsiderationID,
        this.$fun.getUserID()
      );
      this.$emit("refresh");
      this.$emit("close");
    },
    async onDownloadAttachment(rec) {
      if (!rec || !rec.AttachmentPath) {
        this.$fun.alert("No existe anexo.", "warning");
        return;
      }
      try {
        // Si quieres detectar imagen para previsualizar en vez de descargar directo:
        const isImg = /\.(png|jpe?g|gif|webp)$/i.test(rec.AttachmentPath);
        await GenUploadFiles.getFile("routeReconsiderations", rec.AttachmentPath, isImg).then((response) => {
          if (isImg) {
            console.log("Es imagen, previsualizando en modal", response);

            // Mostrar en el modal de previsualización
            this.previewImage = response;
            this.previewDialog = true;
          } else {
            console.log("No es imagen, descargando directo");
            // Descargar directamente
          }
        });
      } catch (e) {
        console.error(e);
        this.$fun.alert("Error al descargar el anexo.", "error");
      }
    },
    downloadBase64(dataUrl, fileName) {
      const arr = dataUrl.split(',');
      if (arr.length < 2) return;
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8 = new Uint8Array(n);
      while (n--) u8[n] = bstr.charCodeAt(n);
      const blob = new Blob([u8], { type: mime });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName || "archivo";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    }
  },
};
</script>
<style scoped>
.timeline-card {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1.5rem;
  transition: all 0.2s ease;
  margin-left: 1rem;
  display: flex;
  align-items: flex-start;
}

.timeline-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.timeline-content {
  flex: 1;
}

.timeline-actions {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  align-content: center;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 1rem;
}

.status-badge.active {
  background: #d1fae5;
  color: #065f46;
}

.status-badge.cancelled {
  background: #fecaca;
  color: #991b1b;
}

.status-badge.reconsideration {
  background: #fef3c7;
  color: #92400e;
}

.time-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 1rem;
  background: #f8fafc;
  border-radius: 6px;
  border-left: 3px solid #e2e8f0;
}

.time-slot {
  display: flex;
  flex-direction: column;
}

.time-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.time-value {
  font-size: 0.95rem;
  font-weight: 600;
  color: #1e293b;
  margin-top: 0.25rem;
}

.observation {
  background: #f1f5f9;
  border-left: 3px solid #3b82f6;
  padding: 1rem;
  /* margin: 1rem 0; */
  border-radius: 0 6px 6px 0;
  font-style: italic;
  color: #475569;
}

.revert-btn {
  background: linear-gradient(135deg, #ef4444, #dc2626) !important;
  color: white !important;
  border-radius: 6px !important;
  font-size: 0.875rem !important;
  margin: auto;
  font-weight: 500 !important;
  transition: all 0.2s ease !important;
}

.revert-btn:hover {
  background: linear-gradient(135deg, #dc2626, #b91c1c) !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(239, 68, 68, 0.3) !important;
}

.download-btn {
  color: #3b82f6 !important;
  /* Un azul bonito */
  margin-right: 8px;
  /* Espacio entre los botones */
}

.download-btn:hover {
  background-color: rgba(59, 130, 246, 0.1);
}

/* Responsivo para móviles */
@media (max-width: 640px) {
  .timeline-card {
    flex-direction: column;
    gap: 1rem;
  }

  .timeline-actions {
    align-self: flex-start;
  }

  .time-info {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
}
</style>
